import React, { useMemo } from "react";
import ReportViewer from "./components/ReportViewer";
import { generateStandardReportPdf } from "./utils/reportPdfGenerators";
import moment from "moment";

export default function DeliverySlaReport() {
  const formatDateTime = (value) => {
    if (!value) return "-";
    const m = moment(value, [moment.ISO_8601, "YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD", "DD/MM/YYYY", "DD/MM/YYYY HH:mm:ss"], true);
    return m.isValid() ? m.format("DD/MM/YYYY hh:mm A") : String(value);
  };

  const columns = useMemo(
    () => [
      { name: "Sales #", selector: (r) => r.SalesNumber || "-" },
      { name: "Customer", selector: (r) => r.CustomerName || "-" },
      { name: "Sales Date", selector: (r) => formatDateTime(r.SalesDate) },
      { name: "Handover Date", selector: (r) => formatDateTime(r.HandoverDate) },
      { name: "TAT (days)", selector: (r) => r.TatDays ?? "-" },
      { name: "Within SLA", selector: (r) => (Number(r.WithinSla) === 1 ? "Yes" : "No") },
    ],
    []
  );

  return (
    <ReportViewer
      reportKey="deliverySla"
      title="Delivery SLA"
      columns={columns}
      fetchConfig={{
        url: "/reports/app2/delivery-sla",
        paramsBuilder: (filters) => ({
          fromDate: filters.fromDate,
          toDate: filters.toDate,
          slaDays: Number(filters.slaDays || 7),
        }),
      }}
      initialFilters={{ slaDays: 7 }}
      renderFilters={(filters, setFilters) => (
        <div className="col-sm-12 col-md-2">
          <label className="form-label">SLA Days</label>
          <input
            type="number"
            className="form-control"
            value={filters.slaDays || 7}
            onChange={(e) => setFilters((p) => ({ ...p, slaDays: e.target.value }))}
          />
        </div>
      )}
      buildKpis={(rows) => {
        const total = rows?.length ?? 0;
        const within = (rows || []).filter((x) => Number(x?.WithinSla) === 1).length;
        const pct = total > 0 ? ((within / total) * 100).toFixed(1) : "0.0";
        return [
          { label: "Total", value: total },
          { label: "Within SLA", value: within },
          { label: "Within %", value: pct },
        ];
      }}
      pdfGenerator={generateStandardReportPdf}
    />
  );
}

